import { clsx } from "clsx";
import { FormattedMessage } from "react-intl";

export enum Tab {
    DAY = "days",
    WEEK = "weeks",
    MONTH = "months",
    YEAR = 'years',
}

type ISelectionTab = {
    id: string;
    type: Tab;
};

type IProps = {
  activeTab: Tab;
    onChange: (tab: Tab) => void;
};

const selectionTab: ISelectionTab[] = [
  {
    id: "meter.statistics.day",
    type: Tab.DAY,
  },
  {
    id: "meter.statistics.week",
    type: Tab.WEEK,
  },
  {
    id: "meter.statistics.month",
    type: Tab.MONTH,
  },
  {
    id: "meter.statistics.year",
    type: Tab.YEAR,
  },
];

export const SelectionTab = ({ activeTab, onChange }: IProps) => {
    return (
      <div className="flex text-gray999 justify-between px-[26px] py-[24px]">
        {selectionTab.map((tab) => (
          <div
            onClick={() => onChange(tab.type)}
            key={tab.id}
            className={clsx(
              "flex items-center justify-center w-[86px] h-[26px]",
              {
                "bg-primary rounded-[44px] text-white": activeTab === tab.type,
              }
            )}
          >
            <FormattedMessage id={ tab.id} />
          </div>
        ))}
      </div>
    );
};
